__turbopack_context__.v({
  "arrow": "RedListIndexSideStats-module__d8V1MW__arrow",
  "pod": "RedListIndexSideStats-module__d8V1MW__pod",
  "root": "RedListIndexSideStats-module__d8V1MW__root",
});
